export const UPDATE_USAGE_STATE = 'UPDATE_USAGE_STATE';
export const CONVERSATION_LOG_STATS_UPDATED = 'CONVERSATION_LOG_STATS_UPDATED';

export const CHAT_SESSION_LOADING='CHAT_SESSION_LOADING';
export const CHAT_SESSION_RECEIVED = 'CHAT_SESSION_RECEIVED';
export const CHAT_SESSION_LOAD_ERROR='CHAT_SESSION_LOAD_ERROR';

export const USER_ENGAGEMENT_STATS_LOADING = 'USER_ENGAGEMENT_STATS_LOADING';
export const USER_ENGAGEMENT_STATS_RECEIVED = 'USER_ENGAGEMENT_STATS_RECEIVED';
export const USER_ENGAGEMENT_STATS_LOAD_ERROR = 'USER_ENGAGEMENT_STATS_LOAD_ERROR';

export const USER_RETENTION_LOADING = 'USER_RETENTION_LOADING';
export const USER_RETENTION_RECEIVED = 'USER_RETENTION_RECEIVED';
export const USER_RETENTION_LOAD_ERROR = 'USER_RETENTION_LOAD_ERROR';



// WEBPACK FOOTER //
// ./src/data/redux/usage_details/actiontypes.js